import dynamic from 'next/dynamic'

export const InvestorCard = dynamic(() => import('./investor-card'))
